import MediaDetailView from '@/pages/detail/components/MediaDetailView';

export default function MovieDetail() {
  return <MediaDetailView expectedKind="movie" />;
}